export default __webpack_public_path__ + "static/media/careyeChiefSignature.d612c8fe.png";